/**
 * ドロップダウンのoptionとしての「クーポンを選択しない」に付与されるvalue。
 * 他の、具体的なクーポンを選択するoptionに付与されるvalueがクーポンIDであるのとは、まったく意味の異なるvalueであり、
 * 形式的なvalueとして空白値を採用している。
 */
export const useNoCouponOptionValue = ''

/**
 * どの項目も選択されていない可能性を、nullとして許容している。
 * nullか否かでUI上の選択状態を判定していることになる。
 * 将来的には、選択状態を加味した独自型を定義してもよい。
 */
export const noCouponOptionSelected = null
